const API_URL = 'https://bookings.naamastudios.com/';
const MONTHS_NAMES = [
  "January", "February", "March", "April",
  "May", "June", "July", "August",
  "September", "October", "November", "December"
];
let PRODUCT_ID = 123456789;
let VARIANT_ID = 123456789;
let PRODUCT_NAME = '';

const removeTimeZone = (date) => {
  console.log('DO -' + date);

  let tzDiff = date.getTimezoneOffset() * 60000;
  console.log(date)

  console.log('PISLA -' + new Date(date.getTime() - tzDiff));
  return new Date(date.getTime() - tzDiff);
}

const buildAvailableHTML = (availableDates) => {
  let html = '';

  let isActive = availableDates[0].hours.filter(time => time.active);

  if (isActive.length > 0) {
    let dayName = availableDates[0].hours.length > 0 ? '<div class="bw-available-date-title">' + availableDates[0].day + '</div>\n' : '';

    html += '' +
      '<div class="bw-available-day-wrapper' + (dayName === "" ? " mb0" : "") + '">\n' +
      dayName +
      '  <div class="bw-available-time-wrapper">\n';

    availableDates[0].hours.forEach((time) => {
      if (time.active) {
        let hours = new Date(time.hour.replace(/\+[0-9]+/, '+0000')).getUTCHours().toLocaleString();
        let minutes = new Date(time.hour).getUTCMinutes().toLocaleString();

        html += '' +
          '<div class="bw-available-time-item active" data-time="' + time.hour + '" data-calendar="' + time.calendar + '">\n' +
          '  <span>' + hours + ':' + ("0" + minutes).slice(-2) + '</span>\n' +
          '</div>';
      }
    })

    html += '' +
      '  </div>\n' +
      '</div>\n';
  } else {
    availableDates.forEach((day, index) => {
      let dayName = day.hours.length > 0 ? '<div class="bw-available-date-title">' + day.day + '</div>\n' : ''
      html += '' +
        '<div class="bw-available-day-wrapper' + (dayName === "" ? " mb0" : "") + '">\n' +
        dayName +
        '  <div class="bw-available-time-wrapper">\n';

      day.hours.forEach((time) => {

        let hours = new Date(time.hour.replace(/\+[0-9]+/, '+0000')).getUTCHours().toLocaleString()
        let minutes = new Date(time.hour).getUTCMinutes().toLocaleString()
        let active = time.active ? ' active' : '';

        html += '' +
          '<div class="bw-available-time-item' + active +'" data-time="' + time.hour + '" data-calendar="' + time.calendar + '">\n' +
          '  <span>' + hours + ':' + ("0" + minutes).slice(-2) + '</span>\n' +
          '</div>';
      })

      html += '' +
        '  </div>\n' +
        '</div>\n';
    })
  }

  return html;
}

const getAvailableDates =  (chosenDate) => {
  let date = encodeURIComponent(chosenDate.toISOString());

  let url = API_URL + 'availability/times?date=' + date + '&variantId=' + VARIANT_ID + '&productId=' + PRODUCT_ID + '&productName=' + PRODUCT_NAME

  return fetch(url, {credentials: "include"})
  .then(response => response.json())
  .then(availableDates => {
    let availableData = [];
    let i = 0;

    for (const [availableDay, availableTimes] of Object.entries(availableDates)) {
      availableData[i] = {}
      let date = new Date(availableDay);
      let monthName = MONTHS_NAMES[date.getMonth()];

      availableData[i].day = monthName + ' ' + date.getDate();

      availableData[i].hours = [];

      let selectedDate = chosenDate.toISOString()
      let chosenDataIsPresent = availableTimes.filter(item => {
        if(selectedDate === new Date(item.time).toISOString() ){
          return item;
        }
      })
      let selectedDatePosition = availableTimes.indexOf(chosenDataIsPresent[0]);

      let availableTimesArray = [];

      if( selectedDatePosition !== -1 ) {
        let beforeDates = availableTimes.slice(0, selectedDatePosition).slice(-4);
        let afterDates = availableTimes.slice(selectedDatePosition).slice(0, 5);
        availableTimesArray = availableTimesArray.concat(beforeDates).concat(afterDates);
      } else {
        if(availableData.length > 0 && availableData[0].hours.length <= 9 && availableData[0].hours.length > 0) {
          let sliceTo = availableData[0].hours.length > 0 ? 9 - availableData[0].hours.length : 9
          let dates = availableTimes.slice(0, sliceTo);
          availableTimesArray = availableTimesArray.concat(dates);
        } else {
          let beforeDays = [];
          let afterDays = [];
          availableTimes.forEach(availableTime => {
            if (new Date(availableTime.time).toISOString() < selectedDate) {
              beforeDays.push(availableTime);
            }
          })
          availableTimes.forEach(availableTime => {
            if (new Date(availableTime.time).toISOString() > selectedDate) {
              afterDays.push(availableTime);
            }
          })

          availableTimesArray = availableTimesArray.concat(beforeDays.slice(-4)).concat(afterDays.slice(0, 5));
        }
      }

      availableTimesArray.forEach(availableTime => {
        let active = selectedDate.replace(/\+[0-9]+/, '+0000') === new Date(availableTime.time.replace(/\+[0-9]+/, '+0000')).toISOString();
        availableData[i].hours.push({hour: availableTime.time, calendar: availableTime.calendar, active: active})
      })

      i++
    }

    return availableData;
  });
}

$(document).ready(() => {
  let $searchButton = $('#bwSearch');
  let $bookButton = $('#bwBookNow');
  let $datePicker = $('.datePicker');
  let $timePicker = $('.timePicker.desktop-only');
  let $timeMobilePicker = $('.timePicker.mobile-only');
  let $availableWrapper = $('.bw-available-wrapper');
  let $errorContainer = $('.bw-error-message');

  VARIANT_ID = $('#bookingVariantId').data('variant-id');
  PRODUCT_ID = $('#bookingVariantId').data('product-id');
  PRODUCT_NAME = $('#bookingVariantId').data('product-title');

  $datePicker.pickadate({
    container: '.bw-form-picker-container',
    weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    firstDay: 1,
    today: '',
    clear: '',
    close: '',
    labelMonthNext: 'Go to the next month',
    labelMonthPrev: 'Go to the previous month'
  });

  let $inputDate = $datePicker.pickadate();
  let pickerDate = $inputDate.pickadate('picker');
  pickerDate.set('min', +0);

  $timePicker.pickatime({
    container: '.bw-form-picker-container',
    min: [7,30],
    max: [21,0],
    clear: '',
    format: 'HH:i',
    formatLabel: 'HH:i',
    klass:{
      frame: 'picker__frame-time'
    }
  });

  let $inputTime = $timePicker.pickatime();
  let pickerTime = $inputTime.pickatime('picker');

  $inputDate.on('change', function() {
    $searchButton.removeAttr('disabled');
  })

  $inputTime.on('change', function() {
    let value = $timePicker.val();
    $timeMobilePicker.find('option[value="' + value + '"]').attr('selected', 'selected');
    $searchButton.removeAttr('disabled');
  })


  $timeMobilePicker.on('change', function() {
    $searchButton.removeAttr('disabled');
  })

  $searchButton.on('click', function() {
    if(!$(this).attr('disabled')) {
      $availableWrapper.removeClass('active');
      $searchButton.find('.loader').css('display', 'inline-block');
      $searchButton.find('.text-search').html('Searching');

      let bookingDate = $inputDate.val();
      let bookingTime = window.innerWidth < 768 ? $timeMobilePicker.val() : $timePicker.val();

      if(bookingDate !== '' && bookingTime !== '') {
        $errorContainer.css('display', 'none');
        let time = bookingTime.split(':')

        let chosenDate = new Date(bookingDate),
          day = chosenDate.getDate(),
          month = chosenDate.getMonth(),
          year = chosenDate.getFullYear();
        let utcDate = Date.UTC(year,month,day,time[0],time[1])

      let availableDates = getAvailableDates(new Date(utcDate)).then(availableDates => {
        let availableHtml = buildAvailableHTML(availableDates)

        if(availableHtml !== ''){
          $availableWrapper.find('.bw-available-content').html(availableHtml);
          $availableWrapper.addClass('active');
          $(this).attr('disabled', 'disabled');
          $(document).trigger('bwDatesReady');
          $searchButton.find('.text-search').html('Search');
        }
        $searchButton.find('.loader').css('display', 'none');
      })
      } else {
        $errorContainer.html('Please select date and time').css('display', 'block');
        $searchButton.find('.loader').css('display', 'none');
        $searchButton.find('.text-search').html('Search');
      }
    }
  });

  $(document).on('bwDatesReady', function() {
    let $timeItem = $('.bw-available-time-item');

    if($timeItem.hasClass('active')) {
      $bookButton.removeAttr('disabled');
      $('.bw-available-title').html('Perfect, the time you have selected is available');
      $('.bw-content')[0].scroll({
        top: 200,
        behavior: 'smooth'
      })
    } else {
      $('.bw-available-title').html('Sorry we don\'t have availability at the time selected, please select from the below');
    }

    $timeItem.on('click', function() {
      $timeItem.not($(this)).removeClass('active');
      $(this).addClass('active');
      $bookButton.removeAttr('disabled');
    });
  })

  $bookButton.on('click', function() {
    if(!$(this).attr('disabled')) {
      $bookButton.find('span').css('display', 'inline-block');
      $bookButton.attr('disabled', 'disabled');
      let chosenData = encodeURIComponent($('.bw-available-time-item.active').data('time'));
      let calendarId = $('.bw-available-time-item.active').data('calendar');
      let url = API_URL + 'block?date=' + chosenData + '&variantId=' + VARIANT_ID + '&productId=' + PRODUCT_ID + '&calendar=' + calendarId

      fetch(url, {credentials: "include"}).
      then(response => response.json())
      .then(data => {
        if (data.id) {
          let bookingDate = new Date(data.start.replace(/\+[0-9]+/, '+0000'));
          let todayDate = new Date();
          let date = bookingDate.getUTCDate().toLocaleString();
          let month = bookingDate.getMonth() + 1;
          let year = bookingDate.getFullYear();
          let hours = bookingDate.getUTCHours().toLocaleString();
          let minutes = bookingDate.getUTCMinutes().toLocaleString();

          let bookingDay = year + '-' + ("0" + month).slice(-2) + '-' +  ("0" + date).slice(-2);
          let bookingTime = ("0" + hours).slice(-2) + ':' + ("0" + minutes).slice(-2)

          let formData = {
            items: [{
              quantity: 1,
              id: VARIANT_ID,
              properties: {
                'Date': bookingDay,
                'Time': bookingTime,
                '_bookingDay_time': todayDate,
                '_booking_id': data.id,
                '_calendar_id': calendarId
              }
            }]
          };
          fetch('/cart/clear.js').then(response => response.json())
          .then(cart => {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => response.json()).then(data => {
              $bookButton.find('span').css('display', 'none')
              window.location.href = '/checkout';
            })
          })
        } else {
          $bookButton.find('span').css('display', 'none')
        }
      })
    }
  })

  $('.bw-header-step-back, .bw-header-close-widget').on('click', function() {
    $('.bw-wrapper').removeClass('expanded');
    pickerDate.set('enable', [6])
    $('body, html').css('overflow-y', 'auto');
  })

  $('.pricingBookNow').on('click', function() {
    let title = $(this).data('product-title');
    VARIANT_ID = $(this).data('product-variant-id');
    PRODUCT_ID = $(this).data('product-id');
    PRODUCT_NAME = title;

    $availableWrapper.find('.bw-available-content').html('');
    $availableWrapper.removeClass('active');
    $searchButton.removeAttr('disabled');
    $searchButton.find('.text-search').html('Search');
    $('.bw-header-product-title p').html(title);
    if (PRODUCT_ID === 6811396341951) {
      pickerDate.set('disable', [6])
    }
    $('.bw-wrapper').addClass('expanded');
    $('body, html').css('overflow-y', 'hidden');
  })
})